<template>
  <div class="flex flex-wrap paddig-responsive">
    <div class="flex w-full text-left center-responsive">
      <h2>{{ $t("select_age") }}</h2>
    </div>
    <div class="flex w-full mt-8">
      <div class="flex flex-col">
        <template v-for="option in options" :key="option.id">
          <label class="flex items-center mb-2">
            <input type="radio" :value="option.value" v-model="selectedAge" @change="showValue()" class="mr-2">
            <span>{{ option.label }}</span>
          </label>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SelectOption } from "@/custom-models/levelingSelector";

export default defineComponent({
  name: 'AgeSelector',
  props: {
    propAge:{ 
      type: Number,
      default: 0.2
    }
  },
  created (){
    this.selectedAge = this.propAge;
  },
  data() {
    return {
      selectedAge: 0.2,
      options: [
        { id: 1, label: this.$t("18_30_age"), value: 0.2 },
        { id: 2, label: this.$t("30_40_age"), value: 0.3 },
        { id: 3, label: this.$t("40_50_age"), value: 0.1 },
        { id: 4, label: this.$t("50_more_age"), value: 0.0 }
      ] as SelectOption[]
    };
  },
  methods: {
    showValue() {
      this.$emit("selectedAge", this.selectedAge);
    }
  }
});
</script>
  